import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import DetailModal from './DetailModal';
import ShowDetailModal from './ShowDetailModal';
import FreeMovieModal from './FreeMovieModal';
import { DetailProvider } from '../context/DetailContext';

const Shell = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === '[') setCollapsed((c) => !c);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <DetailProvider>
      <div className="relative">
        <Sidebar collapsed={collapsed} />
        <main
          className={`relative min-h-screen transition-[padding] duration-300 ${collapsed ? 'pl-[88px]' : 'pl-[260px]'}`}
        >
          {children}
        </main>
        <DetailModal />
        <ShowDetailModal />
        <FreeMovieModal />
      </div>
    </DetailProvider>
  );
};

export default Shell;
